// extracted by mini-css-extract-plugin
export var bodyRow = "_h3-d";
export var cardColumns = "_h3-e";
export var ellipsesOverflow = "_h3-2";
export var flatBottomCorners = "_h3-3";
export var flatTopCorners = "_h3-4";
export var headerActionsDropdown = "_h3-f";
export var headerBottomRow = "_h3-c";
export var headerTopRow = "_h3-b";
export var orderDetailsWrapper = "_h3-0";
export var orderInfoContainer = "_h3-1";
export var productDetails = "_h3-9";
export var productImage = "_h3-5";
export var responsiveTable = "_h3-8";
export var shipmentContainer = "_h3-a";
export var tableBottomLeft = "_h3-6";
export var tableBottomRight = "_h3-7";
export var trackingLink = "_h3-g";